import axios from "axios";

const token = localStorage.getItem('accessToken')
const axiosInstance = axios.create({
    baseURL: 'https://litepounds.azurewebsites.net/api/',
    headers: {
        'Authorization': `Bearer ${token}`,
        timeout: 5000, 
        'Content-Type': 'application/json',
    }
})

export default axiosInstance;